import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.ts";
import "@mdi/font/css/materialdesignicons.css";

import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { createPinia } from "pinia";

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi",
  },
});

const pinia = createPinia();

createApp(App).use(pinia).use(vuetify).use(router).mount("#app");
